import { createRouter, createWebHashHistory, type RouteRecordRaw } from 'vue-router'
import { useAuthStore } from '@/stores/auth'

// 11 模块路由
import workerRoutes from './modules/worker.routes'
import salesRoutes from './modules/sales.routes'
import engineerRoutes from './modules/engineer.routes'
import financeRoutes from './modules/finance.routes'
import warehouseRoutes from './modules/warehouse.routes'
import qualityRoutes from './modules/quality.routes'
import purchasingRoutes from './modules/purchasing.routes'
import hrRoutes from './modules/hr.routes'
import maintenanceRoutes from './modules/maintenance.routes'
import adminRoutes from './modules/admin.routes'
import gmRoutes from './modules/gm.routes'

const routes: RouteRecordRaw[] = [
  {
    path: '/login',
    name: 'login',
    component: () => import('@/modules/auth/Login.vue'),
    meta: { public: true }
  },
  {
    path: '/help',
    name: 'help',
    component: () => import('@/modules/help/HelpCenter.vue')
  },
  {
    path: '/',
    redirect: () => {
      const auth = useAuthStore()
      if (!auth.user) return '/login'
      return `/${auth.user.role}/home`
    }
  },
  ...workerRoutes,
  ...salesRoutes,
  ...engineerRoutes,
  ...financeRoutes,
  ...warehouseRoutes,
  ...qualityRoutes,
  ...purchasingRoutes,
  ...hrRoutes,
  ...maintenanceRoutes,
  ...adminRoutes,
  ...gmRoutes,
  {
    path: '/:catchAll(.*)',
    component: () => import('@/modules/auth/NotFound.vue')
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

// v19.0 P0 守卫 · role 前缀 + admin/gm 全开
// 任何登录用户访问 /sales /worker /gm 等模块前缀必须 role 匹配
// 防 W-001 工人跳 /gm/home 暴露 GM 仪表盘 P0 (2026-05-13 Chrome MCP 实测发现)
const ROLE_PREFIXES = ['worker','sales','engineer','finance','warehouse','quality','purchasing','hr','maintenance','admin','gm']
const ADMIN_ROLES = new Set(['admin','boss','gm']) // 这三角色全权限
const GM_CODE_REGEX = /^GM\d/i // GM01/GM02 等 code 兜底

router.beforeEach((to, _from, next) => {
  const auth = useAuthStore()
  if (to.meta.public) return next()
  if (!auth.user) return next('/login')

  // 拿当前 role + code
  const role = String(auth.user.role || '').toLowerCase()
  const code = String(auth.user.code || '')

  // admin/boss/gm 角色或 GM 开头 code 全开
  if (ADMIN_ROLES.has(role) || GM_CODE_REGEX.test(code)) return next()

  // 拿目标路径首段
  const seg = String(to.path || '').split('/').filter(Boolean)[0] || ''
  if (!seg || !ROLE_PREFIXES.includes(seg)) return next() // 非模块路径放行 (login/profile 等)

  // 守卫: 路径首段必须 = 用户 role
  if (seg !== role) {
    console.warn(`[router] 越权拦截 · ${code}(${role}) 试图访问 /${seg}/*`)
    // 弹 toast (如有) + 跳自家 home
    try {
      const w = window as unknown as { tnToast?: (m: string, t?: string) => void }
      w.tnToast && w.tnToast(`⚠️ 越权访问已拦截 · Truy cập trái phép bị chặn`, 'error')
    } catch (_e) { /* ignore */ }
    return next(`/${role}/home`)
  }

  next()
})

export default router
